import { render, staticRenderFns } from "./xiaoXiangReceiptRecord.vue?vue&type=template&id=5d94af80"
import script from "./xiaoXiangReceiptRecord.vue?vue&type=script&lang=js"
export * from "./xiaoXiangReceiptRecord.vue?vue&type=script&lang=js"
import style0 from "./xiaoXiangReceiptRecord.vue?vue&type=style&index=0&id=5d94af80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports